import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Page from "src/layouts/Page";
import StoreForm from "../../components/StoreForm/StoreForm";
import useCreateStore from "../../hooks/useCreateStore";
import useAdminRegions from "../../hooks/useAdminRegions";
import useAdminAreas from "../../hooks/useAdminAreas";
import { adaptStorePayload } from "../../adapters/adaptStorePayload";

const BACK_PATH = "/users/locations";

const EMPTY_DEFAULTS: StoreFormValues = {
	name: "",
	region: "",
	area: ""
};

const CreateStore = () => {
	const navigate = useNavigate();
	const { mutate: createStore, isLoading } = useCreateStore();
	const { data: regions = [] } = useAdminRegions();
	const { data: allAreas = [] } = useAdminAreas();

	const [selectedRegion, setSelectedRegion] = useState("");

	const filteredAreas = selectedRegion
		? allAreas.filter((a) => a.region && String(a.region.id) === selectedRegion)
		: allAreas;

	const handleSubmit = (values: StoreFormValues) => {
		const payload = adaptStorePayload(values);

		createStore(payload, {
			onSuccess: () => navigate(BACK_PATH)
		});
	};

	return (
		<Page>
			<StoreForm
				defaultValues={EMPTY_DEFAULTS}
				onSubmit={handleSubmit}
				isSubmitting={isLoading}
				regions={regions}
				areas={filteredAreas}
				backPath={BACK_PATH}
				onRegionChange={setSelectedRegion}
			/>
		</Page>
	);
};

export default CreateStore;
